import { Tooltip } from '@lib/components'
import type { ID } from '@octopus-do/octopus-project-core'
import { ga4Selectors } from '@store/reducers/ga4'
import type React from 'react'
import { useSelector } from 'react-redux'

import { clsJoin } from '@/utils'
import css from './styles.module.css'
import { formatCompact, formatEngagement } from './utils'

interface Props {
  nodeId: ID
  url?: string | null
}

// «Ушко» с метриками GA4 — по образцу Estimates: постоянно видимая карточка,
// прикреплённая к правому краю ноды в SEO-режиме. Обёртка — span: NodeSeo
// глушит position у div-детей ноды на hover
// (.node_seo:hover > div { position: initial !important }).
export const GaEar: React.FC<Props> = ({ nodeId, url = null }) => {
  const status = useSelector(ga4Selectors.getStatus)
  const metrics = useSelector(ga4Selectors.getPageMetrics(nodeId))

  // Статус во время обновления (resync, повторный запрос) не меняется, так
  // что прежние цифры остаются на экране сами: мигание пустотой читается
  // как «данные пропали».
  if (status !== 'ok') {
    return null
  }

  // stopPropagation: контейнер ноды по клику открывает SEO-сайдбар,
  // ушко — не кнопка и вести себя ссылкой не должно.
  const swallowClick = (event: React.MouseEvent) => {
    event.stopPropagation()
  }

  // Две разные причины пустого ушка: адреса нет вовсе — и адрес есть, но
  // GA по нему ничего не отдал (например, страницу только что переименовали).
  if (!url) {
    return (
      <span className={css.container} onClick={swallowClick}>
        <span className={css.ear_empty}>no URL</span>
      </span>
    )
  }

  if (metrics === null) {
    return (
      <span className={css.container} onClick={swallowClick}>
        <span className={css.ear_empty}>no data</span>
      </span>
    )
  }

  return (
    <span className={css.container} onClick={swallowClick}>
      <span className={css.ear}>
        <Tooltip content="Views" position="top">
          <span className={clsJoin(css.value, css.value_views)}>
            {formatCompact(metrics.views)}
          </span>
        </Tooltip>
        <Tooltip content="Users" position="top">
          <span className={clsJoin(css.value, css.value_users)}>
            {formatCompact(metrics.users)}
          </span>
        </Tooltip>
        <Tooltip content="Engagement time" position="top">
          <span className={clsJoin(css.value, css.value_time)}>
            {formatEngagement(metrics.engagementSeconds, metrics.users)}
          </span>
        </Tooltip>
      </span>
    </span>
  )
}
